/* eslint-disable */
import axios from "axios";
import { format } from "date-fns";
import '../utils/axios.interceptor';
import { urlCoreBack } from "../configs/config";

const epName = "v1/envio-anteojo-arreglo/";
const epName1 = "v1/anteojo-arreglo/";
const nameItemsText = "Envíos de Anteojos/Arreglos";
const nameItemText = "Envío de Anteojos/Arreglos";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getEnviosAnteojoArreglo = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Envíos de Anteojos/Arreglos";

  _params.accion = "actualizar";

  _params.id_area_origen = localStorage.getItem("id_area_deposito");

  if (params.codigoEnvioAnteojoArreglo) {
    _params.codigo = params.codigoEnvioAnteojoArreglo;
  }

  if (params.codigoOrdenEnvio) {
    _params.codigo = params.codigoOrdenEnvio;
  }

  if (params.sucursalDestino) {
    _params.id_area_destino = params.sucursalDestino;
  }

  if (params.usuario) {
    _params.id_usuario = params.usuario;
  }

  if (params.fechaCreacionDesde) {
    _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
  }

  if (params.fechaCreacionHasta) {
    _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
  }

  if (params.estadoActual) {
    _params.estado_actual = params.estadoActual;
  }

  if (params.fechaEstadoDesde) {
    _params.fecha_estado_desde = format(params.fechaEstadoDesde, "yyyy/MM/dd");
  }

  if (params.fechaEstadoHasta) {
    _params.fecha_estado_hasta = format(params.fechaEstadoHasta, "yyyy/MM/dd");
  }

  if ('rows' in params) {
    _params.rows = params.rows;
  }

  if ('first' in params) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getEnvioAnteojoArreglo = async (parIdEnvioAnteojoArreglo) => {
  let _errorMessage = "Se produjo un error al obtener el Envío de Anteojos/Arreglos";

  let _params = {
    id: parIdEnvioAnteojoArreglo,
    id_area_solicita: localStorage.getItem("id_area_deposito"),
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveEnvioAnteojoArreglo = async (params) => {
  let _errorMessage = `No fue posible guardar el Envío de Anteojos/Arreglos`;

  params.id_area_origen = localStorage.getItem("id_area_deposito");
  params.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epName}`,
      data: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Envío de Anteojos/Arreglos guardado";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-envio-anteojo-arreglo-anteojo-arreglo-not-in-despacho") {
        response.ok = false;
        response.messageText =
          "Al menos un Anteojos/Arreglos ya no se encuentra en el área de despacho";
        response.messageSeverity = "error";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getAnteojoArreglo = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener el Anteojo/Arreglo";

  _params.bandeja = params.bandeja;
  _params.gc_codigo_anteojo_arreglo = params.codigoAnteojoArreglo;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName1}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }

      if (response.data.code === "err-envio-anteojo-arreglo-bandeja-not-found") {
        response.ok = false;
        response.messageText =
          "La bandeja no esta asignada a ningún Anteojo o Arreglo";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-envio-anteojo-arreglo-anteojo-arreglo-not-found") {
        response.ok = false;
        response.messageText =
          "No existe un Anteojo o un Arreglo con el código ingresado";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-envio-anteojo-arreglo-anteojo-arreglo-not-finalized") {
        response.ok = false;
        response.messageText =
          "El Anteojo/Arreglo no se encuentra finalizado actualmente";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-envio-anteojo-arreglo-anteojo-arreglo-not-produccion-despacho") {
        response.ok = false;
        response.messageText =
          "El Anteojo/Arreglo no se encuentra en área de despacho actualmente";
        response.messageSeverity = "error";
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const invalidateEnvioAnteojoArreglo = async (parEnvioAnteojoArreglo) => {
  let _errorMessage = `No fue posible anular ${elLa} ${nameItemText}`;

  parEnvioAnteojoArreglo.id_area = localStorage.getItem("id_area_deposito");
  parEnvioAnteojoArreglo.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "DELETE",
      url: `${urlCoreBack}${epName}`,
      params: parEnvioAnteojoArreglo,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `${nameItemText}` + " anulado";
        response.messageSeverity = "success";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};